import { useEffect, useCallback, useState } from "react";
import { Dropdown } from "../../components/dropdown";
import { ModuleStatusList } from "../../constants/moduleStatusList";
import "../../assets/css/setttings.css";
import { ModulesController } from "../../controllers/modulesController";
import { useToastPromise } from "../../components/toastPromise";
import { MaintenanceDuration } from "./maintenanceDuration";
import Button from "@mui/material/Button";
import { ModulesList } from "../../constants/modulesList";
import { MaintenanceController } from "../../controllers/maintenanceController";

export const AllModules = ({ user }) => {
  const toastPromise = useToastPromise();
  const [loading, setLoading] = useState(false);
  const initialMaintenanceInputs = {
    startDateTime: new Date().toLocaleString(),
    endDateTime: new Date().toLocaleString(),
  };
  const [maintenanceInputs, setMaintenanceInputs] = useState({});
  const [modulesList, setModulesList] = useState([]);
  const [moduleStatuses, setModuleStatuses] = useState({});
  const [originalModuleStatuses, setOriginalModuleStatuses] = useState({});
  const [showMaintenance, setShowMaintenance] = useState({});
  const [showSave, setShowSave] = useState({});
  const onHandleChange = useCallback(
    (value, name) => {
      setModuleStatuses((prevStatuses) => ({
        ...prevStatuses,
        [name]: value,
      }));
      setShowSave((prevShowSave) => ({
        ...prevShowSave,
        [name]: value !== originalModuleStatuses[name],
      }));
      setShowMaintenance((prevShowMaintenance) => ({
        ...prevShowMaintenance,
        [name]: value === "maintenance",
      }));
    },
    [originalModuleStatuses]
  );
  const onDateChange =
    (name) =>
    ({ start, end }) => {
      setMaintenanceInputs((prevInputs) => ({
        ...prevInputs,
        [name]: {
          ...prevInputs[name],
          startDateTime: start.toLocaleString(),
          endDateTime: end.toLocaleString(),
        },
      }));
    };
  const getAllModules = () => {
    setLoading(true);
    toastPromise({
      promise: new Promise((resolve, reject) => {
        ModulesController.getAll({
          resolve: resolve,
          reject: reject,
        });
      }),
      successMessage: (data) => {
        const updatedModules = ModulesList.map((module) => {
          const foundItem = data.docs.find(
            (item) => item.data().name === module.name
          );
          if (foundItem) {
            return {
              ...module,
              id: foundItem.id,
              status: foundItem.data().status,
              maintenanceId: foundItem.data().maintenanceId,
            };
          }
          return module;
        });
        const initialStatuses = {};
        const initialMaintenanceState = {};
        updatedModules.forEach((module) => {
          initialStatuses[module.name] = module.status;
          initialMaintenanceState[module.name] = {
            ...initialMaintenanceInputs,
          };
          if (module?.maintenanceId) {
            getAllMaintenance(module.maintenanceId, module.name);
          }
        });
        setModulesList(updatedModules);
        setModuleStatuses(initialStatuses);
        setOriginalModuleStatuses(initialStatuses);
        setMaintenanceInputs(initialMaintenanceState);
        return "Modules details retrieved successfully.";
      },
      errorMessage: (data) => data,
    }).finally(() => setLoading(false));
  };
  const getAllMaintenance = (maintenanceId, moduleName) => {
    setLoading(true);
    toastPromise({
      promise: new Promise((resolve, reject) => {
        MaintenanceController.get({
          id: maintenanceId,
          resolve: resolve,
          reject: reject,
        });
      }),
      successMessage: (data) => {
        const maintenanceData = data.data();
        if (maintenanceData) {
          setShowMaintenance((prevShowMaintenance) => ({
            ...prevShowMaintenance,
            [moduleName]: true,
          }));
          setMaintenanceInputs((prevInputs) => ({
            ...prevInputs,
            [moduleName]: {
              startDateTime: new Date(
                maintenanceData.startDateTime
              ).toLocaleString(),
              endDateTime: new Date(
                maintenanceData.endDateTime
              ).toLocaleString(),
            },
          }));
        }
        return "Maintenance details retrieved successfully.";
      },
      errorMessage: (data) => data,
    }).finally(() => setLoading(false));
  };
  const handleSubmit = ({ id = "", label, name }) => {
    if (moduleStatuses[name] === "maintenance") {
      saveMaintenance(name)
        .then((maintenanceId) => {
          saveModules({
            id: id,
            label: label,
            name: name,
            maintenanceId: maintenanceId,
          });
        })
        .finally(() => {
          setLoading(false);
          setShowSave((prevShowSave) => ({
            ...prevShowSave,
            [name]: false,
          }));
          getAllModules();
        });
    } else {
      if (originalModuleStatuses[name] === "maintenance") {
        modulesList.map((module) => {
          if (module?.maintenanceId)
            deletePreviousMaintenance(module.maintenanceId);
        });
      }
      saveModules({
        id: id,
        label: label,
        name: name,
        maintenanceId: "",
        finallyFunc: () => {
          setLoading(false);
          setShowSave((prevShowSave) => ({
            ...prevShowSave,
            [name]: false,
          }));
          getAllModules();
        },
      });
    }
  };
  const saveMaintenance = (name) => {
    setLoading(true);
    return new Promise((resolve, reject) => {
      MaintenanceController.addGetId({
        parameters: {
          ...maintenanceInputs[name],
          createdBy: user.uid,
          createdDate: new Date().toLocaleString(),
          lastModifiedBy: user.uid,
          lastModifiedDate: new Date().toLocaleString(),
        },
        resolve: resolve,
        reject: reject,
      });
    });
  };
  const saveModules = ({
    id = "",
    label,
    name,
    maintenanceId = "",
    finallyFunc = () => {},
  }) => {
    toastPromise({
      promise: new Promise((resolve, reject) => {
        id
          ? ModulesController.update({
              parameters: {
                id: id,
                label: label,
                name: name,
                status: moduleStatuses[name],
                maintenanceId: maintenanceId,
                lastModifiedBy: user.uid,
                lastModifiedDate: new Date().toLocaleString(),
              },
              resolve: resolve,
              reject: reject,
            })
          : ModulesController.add({
              parameters: {
                label: label,
                name: name,
                status: moduleStatuses[name],
                maintenanceId: maintenanceId,
                createdBy: user.uid,
                createdDate: new Date().toLocaleString(),
                lastModifiedBy: user.uid,
                lastModifiedDate: new Date().toLocaleString(),
              },
              resolve: resolve,
              reject: reject,
            });
      }),
      successMessage: (data) => {
        return data;
      },
      errorMessage: (data) => data,
    }).finally(finallyFunc);
  };
  const deletePreviousMaintenance = (id) => {
    toastPromise({
      promise: new Promise((resolve, reject) => {
        MaintenanceController.delete({
          id: id,
          resolve: resolve,
          reject: reject,
        });
      }),
      successMessage: () => {
        return "Selected item deleted successfully.";
      },
      errorMessage: (data) => data,
    });
  };
  useEffect(() => {
    getAllModules();
  }, []);

  return (
    <section id="modulesList">
      <h4>MODULES LIST</h4>
      <hr />
      {modulesList.map((item) => (
        <div key={item.name}>
          <div className="wrapper">
            <Dropdown
              name={`${item.name}Status`}
              title={item.label}
              value={moduleStatuses[item.name] || item.status}
              options={ModuleStatusList}
              onChangeFunc={(value) => onHandleChange(value, item.name)}
              isClearable={false}
              placeholder={`${item.label} Status`}
            />
            {showSave[item.name] && (
              <Button
                onClick={() =>
                  handleSubmit({
                    id: item.id,
                    label: item.label,
                    name: item.name,
                  })
                }
                disabled={loading}
              >
                {loading ? "Saving" : "Save"}
              </Button>
            )}
          </div>
          {showMaintenance[item.name] && (
            <div>
              <MaintenanceDuration
                onChange={onDateChange(item.name)}
                initialStartDateValue={
                  maintenanceInputs[item.name]?.startDateTime
                    ? new Date(maintenanceInputs[item.name]?.startDateTime)
                    : new Date()
                }
                initialEndDateValue={
                  maintenanceInputs[item.name]?.endDateTime
                    ? new Date(maintenanceInputs[item.name]?.endDateTime)
                    : new Date()
                }
              />
              <hr />
            </div>
          )}
        </div>
      ))}
    </section>
  );
};
